<template>
    <v-btn-toggle v-model="query.state" tile color="secondary" @change="setQuery">
        <v-btn v-for="{ text, value } in items" :key="text" v-bind="{ value }">{{ text }}</v-btn>
    </v-btn-toggle>
</template>

<script>
import { attrs_input, USER_POINT_ORDER_STATES } from "@/assets/variables";

import ListSearch from "@/components/console/dumb/list-search.vue";

let initQuery = (query = {}) => ({
    ...query,
    ["state"]: query?.["state"] || null,
});

const items = [{ text: "전체", value: null }].concat(Object.values(USER_POINT_ORDER_STATES));

export default {
    components: {
        ListSearch,
    },
    props: {
        showsSearch: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        items,

        attrs_input,
    }),
    mounted() {
        this.sync();
    },

    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        setQuery() {
            const { ...query } = this.$route.query || {};

            query.state = this.query.state;
            if (!query.state) delete query.state;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
